module.exports = __webpack_public_path__ + "static/img/computing-power-platform-homepage.917bfea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/computing-power-platform-homepage.png
// module id = djS3
// module chunks = 1